<template>
    <label class="input-container">
        <input class="form-control" type="text" @input="onInput" v-model.number="ownVal" @focus="onFocus"/>
        <span class="unit">{{ unit }}</span>
    </label>
</template>

<script>
  export default {
    name: 'CoddinNumber',
    props: {
      unit: {
        type: String,
      },
      val: {
        default: 0,
      },
    },
    data() {
      return {
        ownVal: this.val,
      }
    },
    watch: {
      val(val) {
        this.ownVal = this.val;
      }
    },
    methods: {
      onFocus() {
        this.$emit('focus');
      },
      onInput(e) {
        this.$emit('codd_input', e.target.value.replace(',', '.'));
      }
    },
  }
</script>

<style lang="scss">
    .input-container {
        display: flex;
        align-items: center;
        border-radius: 50px;
        border: 2px solid #EBEBEB;
        /*margin: 0 15px;*/
        padding: 0;
        flex-shrink: 1;

        input {
            margin: 0 auto;
            width: 100%;
            border: none !important;
            border-radius: 50px 0 0 50px !important;
            font-size: 14px;

            &:focus {
                outline: none !important;
                border: none !important;
                box-shadow: none;
            }
        }

        .form-group {
            position: relative;
        }

        span.unit {
            display: block;
            color: black;
            font-size: 12px;
            font-family: neue-haas-grotesk-text, sans-serif;
            font-weight: 700;
            font-style: normal;
        }
    }
</style>
